export var SET_CURRENT_STATE = 'SET_CURRENT_STATE';
export var SET_START_END_TIME = 'SET_START_END_TIME';
export var RE_RENDER_GRAPH = 'RE_RENDER_GRAPH';
export var WELLNESS_DATA = 'WELLNESS_DATA';
